<template>
  <div class="modal fade modal-driver-add" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Add New Driver
        </div>
        <div class="modal-body">
          <div class="form-group-outer">
            <div class="form-group float-label-control" :class="{ 'has-error': errors.has('name')}">
              <label for="">Driver Name</label>
              <input type="text" v-model="name" v-validate="'required'" name="name" class="form-control" placeholder="Driver Name" v-float-label/>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Mobile Number</label>
              <input type="text" v-model="mobile" class="form-control" placeholder="Mobile Number" v-float-label/>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Email Address</label>
              <input type="text" v-model="email" class="form-control" placeholder="Email Address" v-float-label/>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Drivers Licence</label>
              <input type="text" v-model="licence" class="form-control" placeholder="Drivers Licence" v-float-label/>
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">Licence Expiry</label>
              <date-range v-model="licenceExpiry" name="expiry" :single-date-picker="true" opens="right" v-float-label></date-range>
            </div>
          </div>

          <photo-cropper
            v-model="photo"
            name="driver"
            :photo-storage-path="driver.photo_storage_path"
            class-name="profile-photo"
            label-text="Profile Photo">
          </photo-cropper>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
          <ladda-button type="success" size="small" :on-click="handleSaveDriver"> Create Driver</ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState, mapActions } from 'vuex'
  import { LaddaButton, DateRange, Selectize, PhotoCropper } from 'components/forms'
  import { RESET_DRIVER, SET_DRIVER_ATTRIBUTE } from 'vx/mutations'
  import { stateMapper } from 'mixins/drivers'
  import { notify } from 'utils'
  import $ from 'jquery'

  export default {
    mixins: [stateMapper],

    props: ['truckUser'],

    data () {
      return {
        photo: null
      }
    },

    components: {
      LaddaButton,
      DateRange,
      Selectize,
      PhotoCropper
    },

    computed: {
      ...mapState('driver', ['driver']),

      driverWithUser () {
        return Object.assign({}, this.driver, {
          user_id: this.truckUser
        })
      }
    },

    created () {
      this[RESET_DRIVER]()

      if (this.truckUser) {
        this.user = this.truckUser
      }
    },

    /**
     * On mounted bind a modal event to reset the driver.
     *
     * @return void
     */
    mounted () {
      $('.modal-driver-add').on('show.bs.modal', this.resetDriverAndPhoto)
    },

    /**
     * Before destroy remove the modal event.
     *
     * @return void
     */
    beforeDestroy () {
      $('.modal-driver-add').off('show.bs.modal', this.resetDriverAndPhoto)
    },

    watch: {
      /**
       * When the route changes we need to reset the driver because this form is used
       * to create and edit drivers. We will also attempt to reload an existing
       * driver from the database.
       */
      '$route' () {
        this[RESET_DRIVER]()
      },

      truckUser (value) {
        this.user = this.truckUser
      }
    },

    methods: {
      ...mapMutations('driver', [RESET_DRIVER, SET_DRIVER_ATTRIBUTE]),

      ...mapActions('driver', [
        'storeDriver',
        'uploadDriverPhoto'
      ]),

      /**
       * Reset the driver and the photo.
       *
       * @return void
       */
      resetDriverAndPhoto () {
        this[RESET_DRIVER]()

        this.photo = null
      },

      /**
       * Handle saving a new driver.
       *
       * @return Promise
       */
      handleSaveDriver () {
        const reportMissingNameError = () => {
          if (this.errors.has('name')) {
            notify.error('A driver name is required.')
          }
        }

        const attemptToStoreDriver = () => {
          const emitResponseAndHideModal = (response) => {
            this.$emit('input', response.data)

            $('.modal-driver-add').modal('hide')
          }

          return this.storeDriver(this.driverWithUser).then(this.handlePhotoUpload).then(emitResponseAndHideModal)
        }

        return this.validateAll().then(attemptToStoreDriver).catch(reportMissingNameError)
      },

      /**
       * Handle uploading driver photo.
       *
       * @param object response
       *
       * @return Promise
       */
      handlePhotoUpload (response) {
        if (this.photo) {
          return this.uploadDriverPhoto({ id: response.data.id, file: this.photo.file, crop: this.photo.crop })
        }

        return Promise.resolve(response)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DriverModal.vue?75da1361